import * as React from "react";
import styled from "styled-components";
import useProductName from "brand-customization/useProductName";
import { adjustFormat } from "util/DateTime";
import { Col, Row } from "components/bootstrap";
import { Spinner } from "components/common";
import useActiveLicenseInformation from "license/hooks/useActiveLicenseInformation";
import { LICENSE_TYPE, LICENSE_TYPES } from "license/constants";
import LicenseState from "license/LicenseState";
import { useGraphWidth } from "components/common/Graph";
import NumberUtils from "util/NumberUtils";
import ActiveDrawDownLicenseMetrics from "license/ActiveDrawDownLicenseMetrics";
import ActiveLicenseMetrics from "license/ActiveLicenseMetrics";
import TrafficGraph from "license/TrafficGraph";
import GraphDaysContextProvider from "components/common/Graph/contexts/GraphDaysContextProvider";
const StyledDl = styled.dl`
  margin: 0;

  dt {
    float: left;
    clear: left;
  }

  dd {
    margin-left: 260px;
  }
`;
const ActiveLicenseInformation = () => {
  var _a;
  const productName = useProductName();
  const { graphContainerRef } = useGraphWidth();
  const {
    data: activeLicenseData,
    isLoading: isLoadingActiveLicense,
    isError: isErrorActiveLicense
  } = useActiveLicenseInformation();
  const formatDateTime = (dateTimeToFormat) => adjustFormat(dateTimeToFormat, "date");
  if (isLoadingActiveLicense) return /* @__PURE__ */ React.createElement(Spinner, null);
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(GraphDaysContextProvider, null, /* @__PURE__ */ React.createElement(Col, { xs: 6, ref: graphContainerRef }, /* @__PURE__ */ React.createElement(TrafficGraph, null))), /* @__PURE__ */ React.createElement(Col, { xs: 6 }, isErrorActiveLicense || !activeLicenseData ? /* @__PURE__ */ React.createElement("p", null, "No active license found.") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledDl, null, /* @__PURE__ */ React.createElement("dt", null, "Active License Type:"), /* @__PURE__ */ React.createElement("dd", null, activeLicenseData.license_type), /* @__PURE__ */ React.createElement("dt", null, "Product:"), /* @__PURE__ */ React.createElement("dd", null, activeLicenseData.license_type === LICENSE_TYPE.drawDown ? activeLicenseData.products.split(",").join(", ") : `${productName} ${LICENSE_TYPES[activeLicenseData.products]}`), typeof ((_a = activeLicenseData.details) == null ? void 0 : _a.require_remote_check) === "boolean" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Requires Remote Checks:"), /* @__PURE__ */ React.createElement("dd", null, String(activeLicenseData.details.require_remote_check))), /* @__PURE__ */ React.createElement("dt", null, "State:"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(
    LicenseState,
    {
      violations: activeLicenseData.violations,
      version: activeLicenseData.details.version,
      evaluated: activeLicenseData.violations_evaluated
    }
  )), activeLicenseData.license_type === LICENSE_TYPE.drawDown ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Provision:"), /* @__PURE__ */ React.createElement("dd", null, NumberUtils.formatBytes(activeLicenseData.details.traffic_provisioned)), /* @__PURE__ */ React.createElement("dt", null, "Remaining:"), /* @__PURE__ */ React.createElement("dd", null, NumberUtils.formatBytes(activeLicenseData.details.traffic_limit)), /* @__PURE__ */ React.createElement("dt", null, "Expires:"), /* @__PURE__ */ React.createElement("dd", null, formatDateTime(activeLicenseData.end_date))) : /* @__PURE__ */ React.createElement(ActiveLicenseMetrics, null)), activeLicenseData.license_type === LICENSE_TYPE.drawDown && /* @__PURE__ */ React.createElement(ActiveDrawDownLicenseMetrics, null))));
};
export default ActiveLicenseInformation;
